import Text, { TEXT_TYPE } from "component/design-system/typography/Text";
import SafeLink from "modules/components/SafeLink";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { getRelativeImagePath } from "../../util/helper/getRelativeImagePath";
import styles from "./all-articles.module.scss";

function AllArticles(props: any) {
  const { articles } = props;
  const router = useRouter();
  const { locale } = router;

  return (
    <div className="row d-flex flex-wrap m-lr-0">
      {articles.map((each: any, index: number) => (
        <SafeLink key={index} href={each.url} prefetch={false} className={`col-lg-4 col-md-4 col-sm-4 col-xs-12 p-lr-5 ${styles.eachArticle} ${styles.article_item}`}>

          <Image
            unoptimized
            src={getRelativeImagePath(`${each.imgSrc}`)}
            alt={each.alt}
            height={230}
            width={400}
          />
          <Text size={4} bold className={styles.articles_image_title}>
            {locale === "fr" ? each.fr_title : each.title}
          </Text>
          <Text size={5} style={{ lineHeight: 1.4 }} type={TEXT_TYPE.secondary}>
            {locale === "fr" ? each.fr_subtitle : each.subtitle}
          </Text>
          <div className="d-flex align-items-center">
            <Text size={5} style={{ lineHeight: 1.4 }} type={TEXT_TYPE.secondary} className="p-r-5">
              by
            </Text>
            <Text size={5} bold style={{ lineHeight: 1.4 }} className="p-r-5">
              {each.author}
            </Text>
            {" "}
            |
            <Text size={5} style={{ lineHeight: 1.4 }} type={TEXT_TYPE.secondary} className="p-l-5">
              {each.date?.split("T")[0]}
            </Text>
          </div>
        </SafeLink>
      ))}
    </div>
  );
}

export default AllArticles;
